import { css } from '@emotion/react';
import { type Theme } from '../../themes/theme.model';
import {
  type AlertSize, type AlertType,
} from './alert.component';

type AlertTheme = {
  primary: string;
  secondary: string;
};

export const getThemeForAlertType = (type: AlertType, theme: Theme): AlertTheme => {
  switch (type) {
    case 'danger':
      return {
        primary: theme.alertColors.dangerPrimary,
        secondary: theme.alertColors.dangerSecondary,
      };
    case 'success':
      return {
        primary: theme.alertColors.successPrimary,
        secondary: theme.alertColors.successSecondary,
      };
    case 'info':
      return {
        primary: theme.alertColors.infoPrimary,
        secondary: theme.alertColors.infoSecondary,
      };
    case 'warning':
      return {
        primary: theme.alertColors.warningPrimary,
        secondary: theme.alertColors.warningSecondary,
      };
    case 'dangerAlternative':
      return {
        primary: theme.textColors.quaternary,
        secondary: theme.alertColors.dangerAlternative,
      };
    case 'successAlternative':
      return {
        primary: theme.textColors.quaternary,
        secondary: theme.alertColors.successAlternative,
      };
    default:
      return {
        primary: theme.alertColors.successPrimary,
        secondary: theme.alertColors.successSecondary,
      };
  }
};

export const alertContainerStyle = ({
  type, size, reverseColors, transparentBackground, hasCloseButton, withoutBorder,
}: {
  type: AlertType;
  size: AlertSize;
  reverseColors?: boolean;
  transparentBackground?: boolean;
  hasCloseButton: boolean;
  withoutBorder?: boolean;
}) => (theme: Theme) => {
  const alertTheme = getThemeForAlertType(type, theme);
  const borderTextColor = reverseColors ? alertTheme.secondary : alertTheme.primary;

  return css({
    background: reverseColors ? alertTheme.primary : (transparentBackground ? undefined : alertTheme.secondary),
    border: withoutBorder ? 'none' : `1px solid ${borderTextColor}`,
    borderRadius: 4,
    color: borderTextColor,
    cursor: 'default',
    fontSize: size === 'small' ? 14 : 18,
    fontWeight: 600,
    minHeight: size === 'small' ? 16 : 20,
    padding: size === 'small' ? '8px 12px 8px 12px' : '8px 25px',
    paddingRight: hasCloseButton ? (size === 'small' ? 26 : 32) : undefined,
    position: 'relative',
    textAlign: 'center',
  });
};

export const buttonStyle = (theme: Theme) => css({
  position: 'absolute',
  top: 8,
  right: 5,
  background: 'none',
  color: 'inherit',
  border: 'none',

  '&:hover': {
    color: theme.textColors.secondary,
  },
});
